import React from 'react'
import { useUserContext } from '../context/users/UserContext'
import { validatePermissions } from '../context/users/UserActions'
import { Link } from 'react-router-dom'
import { 
  FaUser, 
  FaUsers, 
  FaChartBar, 
  FaPlus, 
  FaEye,
  FaCheckCircle,
  FaPlay,
  FaYoutube,
  FaClock,
  FaEye as FaEyeIcon
} from 'react-icons/fa'
import { Card, Row, Col, Badge } from 'react-bootstrap'
import './Home.css'

// Datos del tutorial principal
const mainTutorial = {
  id: 1,
  title: "Tutorial de Uso del Sistema",
  description: "Aprende a utilizar todas las funcionalidades principales de la plataforma Alleanza",
  youtubeId: "y75GVeffBkQ",
  duration: "15:30",
  views: "1.2K",
  level: "BÁSICO",
  available: true
}

// eslint-disable-next-line
export default function (props) {
  const { authenticatedUser } = useUserContext()

  window.scrollTo({
    top: 0,
    behavior: 'auto',
  })


  const getGreeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Buenos días'
    if (hour < 18) return 'Buenas tardes'
    return 'Buenas noches'
  }

  const getUserRole = () => {
    if (validatePermissions(authenticatedUser.permissions, 'isAdmin')) return 'Administrador'
    if (validatePermissions(authenticatedUser.permissions, 'isHost')) return 'Anfitrión'
    return 'Usuario'
  }

  const openInYouTube = () => {
    window.open(`https://www.youtube.com/watch?v=${mainTutorial.youtubeId}`, '_blank')
  }

  return (
    <div className="home-dashboard">
      {/* Header Moderno */}
      <div className="modern-header">
        <div className="header-main">
          <div className="greeting-section">
            <div className="greeting-text">
              <h1 className="main-greeting">
                {getGreeting()}
              </h1>
              <h2 className="user-name">
                {authenticatedUser.fullName || 'Usuario'}
              </h2>
              <div className="user-badge">
                <span className="badge-icon">👤</span>
                <span className="badge-text">{getUserRole()}</span>
                {authenticatedUser.organization && (
                  <>
                    <span className="badge-separator">•</span>
                    <span className="badge-org">{authenticatedUser.organization}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          
          <div className="date-section">
            <div className="date-info">
              <div className="current-date">
                {new Date().toLocaleDateString('es-ES', {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long'
                })}
              </div>
              <div className="current-time">
                {new Date().toLocaleTimeString('en-US', {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Acciones Rápidas */}
      <Row className="actions-row">
        <Col lg={12}>
          <div className="quick-actions-modern">
            <div className="actions-grid">
              {validatePermissions(authenticatedUser.permissions, 'session') && (
                <Link to="/session" className="action-card">
                  <div className="action-icon">
                    <FaPlus />
                  </div>
                  <div className="action-info">
                    <h4>Crea tu sesión de trabajo</h4>
                  </div>
                  <div className="action-arrow">
                    →
                  </div>
                </Link>
              )}
              
              {validatePermissions(authenticatedUser.permissions, 'session') && (
                <Link to="/sessions" className="action-card">
                  <div className="action-icon">
                    <FaEye />
                  </div>
                  <div className="action-info">
                    <h4>Consulta tus sesiones</h4>
                  </div>
                  <div className="action-arrow">
                    →
                  </div>
                </Link>
              )}

              {validatePermissions(authenticatedUser.permissions, 'isAdmin') && (
                <Link to="/usuarios" className="action-card">
                  <div className="action-icon">
                    <FaUsers />
                  </div>
                  <div className="action-info">
                    <h4>Gestionar Usuarios</h4>
                    <p>Administrar usuarios del sistema</p>
                  </div>
                  <div className="action-arrow">
                    →
                  </div>
                </Link>
              )}

              {validatePermissions(authenticatedUser.permissions, 'session') && (
                <Link to="/reportes" className="action-card">
                  <div className="action-icon">
                    <FaChartBar />
                  </div>
                  <div className="action-info">
                    <h4>Consulta tus reportes y estadísticas</h4>
                  </div>
                  <div className="action-arrow">
                    →
                  </div>
                </Link>
              )}
            </div>
          </div>
        </Col>
      </Row>

      {/* Widget de Tutoriales */}
      <Row className="tutorial-widget-row">
        <Col lg={12}>
          <Card className="tutorial-widget-card">
            <Card.Body>
              <Row>
                <Col lg={8} md={12}>
                  <div className="tutorial-video-section">
                    <div className="tutorial-video-wrapper">
                      <iframe
                        width="100%"
                        height="250"
                        src={`https://www.youtube.com/embed/${mainTutorial.youtubeId}?si=RS3zdN-_3M7-W6rm`}
                        title={mainTutorial.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                    
                    <div className="tutorial-actions">
                      <button 
                        className="youtube-btn"
                        onClick={openInYouTube}
                      >
                        <FaYoutube className="me-2" />
                        Ver en YouTube
                      </button>
                    </div>
                  </div>
                </Col>
                
                <Col lg={4} md={12}>
                  <div className="tutorial-info-section">
                    <h3 className="tutorial-title">{mainTutorial.title}</h3>
                    <p className="tutorial-description">{mainTutorial.description}</p>
                    
                    <div className="tutorial-metadata">
                      <div className="metadata-item">
                        <FaClock className="metadata-icon" />
                        <span>{mainTutorial.duration}</span>
                      </div>
                      <div className="metadata-item">
                        <FaEyeIcon className="metadata-icon" />
                        <span>{mainTutorial.views} visualizaciones</span>
                      </div>
                      <div className="metadata-badge">
                        <span className={`level-badge ${mainTutorial.level.toLowerCase()}`}>
                          {mainTutorial.level}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
